import { defineComponent as _defineComponent } from 'vue'
import { computed, useRoute, watch, useStore } from '@nuxtjs/composition-api';
import RibbonMenu from '~/components/header/ribbon-menu/Menu.vue';
import { State } from '~/store';
import megaMenuLinks from '~/data/mega_menu_links';
import { useTwoRowHeader } from '~/composables/useTwoRowHeader';
import { useLocale } from '~/composables/useLocale';

export default /*#__PURE__*/_defineComponent({
  __name: 'MegaMenu',
  setup(__props) {

const { navigationUserClickedEvent } = useTwoRowHeader();
const store = useStore<State>();
const route = useRoute();

const locale = useLocale();
const trendingTopics = computed(() => store.getters.trendingTopics?.slice(0, 4));
const megaMenuOpen = computed(() => store.getters.megaMenuOpen);

watch(route, () => {
  store.dispatch('toggleMegaMenu');
});

const toggleMegaMenu = () => {
  store.dispatch('toggleMegaMenu', !megaMenuOpen.value);
};

return { __sfc: true,navigationUserClickedEvent, store, route, locale, trendingTopics, megaMenuOpen, toggleMegaMenu, RibbonMenu, megaMenuLinks }
}

})